import index from './index/index';
export default index;


// WEBPACK FOOTER //
// ./src/pages/index.js